import styled from "styled-components";
import colours from "styles/colours";

export const HomepageFrame = styled.div`
  position: relative;

  &::before {
    content: "";
    position: absolute;
    left: 0;
    top: 3rem;
    bottom: 3rem;
    width: 1px;
    background-color: ${colours.elexonBlue};
  }
`;
